package site.shadadman.pages.worklog.alfatechnology

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initOct122014AlfaTechnologyFirstSprintPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/alfatechnology/oct122014AlfaTechnologyFirstSprint.md", FrontMatterElement.Builder { addScalar("title", "oct122014AlfaTechnologyFirstSprint"); }))
}

@Page("/worklog/alfatechnology/oct122014-alfa-technology-first-sprint")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun Oct122014AlfaTechnologyFirstSprintPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("oct-12-2014-AlfaTechnology-First-Sprint")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This marks the beginning of an amazing era. This is my first official company based job. I have worked as a freelancer and will always return to it when needed. However, working with a professional team brings a new, exciting dimension to my job as a developer.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This small organization had a fabulous idea. They developed an SMS based hardware that attaches to a car, allowing users to create an advanced remote control with no distance limitations. The car owner can lock/unlock the car doors, turn the car on/off, and the hardware can send alarms directly to the phone in case of a collision or unexpected door opening.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("They needed an Android Developer to create an app that detects this SMS pattern. Users could then use the app instead of sending raw SMS messages. They had a nice design for the home page, which looked like a real car remote control.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The first two weeks were spent familiarizing myself with the hardware, thinking of our Android project arch, the SMS patterns, and doing R&D on reading SMS on Android devices, as well as making good friends among my team, which included a designer, my CTO, and our hardware team.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I had also worked with our CEO, Ata Amini, on a small freelance project, and that was the beginning of our working relationship.")
    }
}
